module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gFj9hy/tc-custom/9781788636391.jpg?1717183236061",
      "alt": "This image is the cover for the book Wild Heritage, A Bridge in Time"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wild Heritage, A Bridge in Time\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A historical saga detailing the lives of two female friends bonded by their difficult childhoods whose relationship stands the test of time.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Thirteen years have passed since the railway came to the Borders, bringing changes that would radically alter the lives of the people who lived there. Yet the steam train was not the only legacy from the men who built the railway—in their wake they left several fatherless children."), _c('br'), _c('br'), _vm._v(" One such child is Kitty Scott. Wild through neglect and an outcast within the community, Kitty is a loner . . . until she rescues newcomer Marie Benjamin from the taunts of her classmates—the same taunts that have clouded Kitty’s own life. So begins a friendship that lasts beyond their childhood in the Scottish Borders, to Edinburgh, London, and finally Paris, where the influence of heredity comes full circle and friendship’s true worth is recognized. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elisabeth McNeill\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Elisabeth McNeill was a long-established freelance journalist and broadcaster who wrote five non-fiction books and 26 novels. She lived with a miniature dachshund in the oldest inhabited village on the Scottish borders, where she spent most of her school days.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Digital Publishing Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0